export const PORTS_INVOKE = 'wh.gaming-lobby.command.port.invoke';
export const PORTS_SUBSCRIBE = 'wh.gaming-lobby.command.port.listener.add';
export const PORTS_UNSUBSCRIBE = 'wh.gaming-lobby.command.port.listener.remove';
